 
 
import React, { FC, memo, useState,useEffect,useRef } from "../../../../lib/teact/teact";
import { copyTextToClipboard } from "../../../../util/clipboard";
import Button from "../../../ui/Button";
import { LotScreenSettings } from "../../config/uiconfig";
import { updateEditedMessageId } from "../../redux/global";
import store from "../../store";
import Snackbar from "../../ui/snackbar";
import { getDateStringVN } from "../../utils/DateTimeUtils";
import { writeDetailsReportHtmlFile, writeTotalReportHtmlFile } from "./reportHtmlFileWriter";


type OwnProps = {
    data: any;
    messageIndex: number;

    onChangeViewType: (viewType: string, index: number) => void;
    onRemoveItem: (index: number) => void;
    onReloadItem?: (index: number) => void;
    hideToolbar?: boolean;
    onChangeScreen: (toScreen: LotScreenSettings) => void;
    soTin:number;
    hilight?:string;
}

const MessageView: FC<OwnProps> = ({
    data,
    messageIndex,

    onChangeViewType,
    onRemoveItem,
    onReloadItem,
    hideToolbar,
    onChangeScreen,
    soTin,
    hilight,
    
}) => {
    const [state, setState] = useState({
        snackbarOpen: false,
        snackbarMessage: ""
    })
    const bodyRef = useRef<HTMLDivElement>(null);
    useEffect (()=>{
        if (hilight){
            console.log("Hilight "+ hilight)
            if (bodyRef.current) {
                bodyRef.current.innerHTML = hilight;
            }
        }
    },[hilight])
    function getCurrentTotalDisplayTemplete(): 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | undefined {
        const smsIndex = Number(localStorage["smsIndex"]);
        if (Number.isInteger(smsIndex) && smsIndex >= 0 && smsIndex <= 9) {
            return smsIndex as 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
        }
        return undefined;
    }
    async function handleDownloadHtml(event: React.MouseEvent<HTMLElement>) {
        if (event.stopPropagation) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!data) {
            setState(prev => ({
                ...prev, snackbarOpen: true,
                snackbarMessage: "Không có dữ liệu để tải"
            }));
            return;
        }
        if (data.viewType == "details") {
            const downloadedFile = await writeDetailsReportHtmlFile(data);
            setState(prev => ({
                ...prev, snackbarOpen: true,
                snackbarMessage: "Đã tải file details: " + downloadedFile
            }));
        } else {
            const downloadedFile = await writeTotalReportHtmlFile(data, {
                totalDisplayTemplete: getCurrentTotalDisplayTemplete(),
            });
            setState(prev => ({
                ...prev, snackbarOpen: true,
                snackbarMessage: "Đã tải file total: " + downloadedFile
            }));
        }
    }
    return (
        <div className={data.messageId == 0 ? "message-body total" : "message-body"}>
            <div ref={bodyRef}
                 className={data.messageId == 0 ? "message-body total"
                : (data.type == 1 ? "message-body details-in" : "message-body details")} >
                {/* CHÚ Ý, NẾU TIN NHẮN QUÁ DÀI, SẼ LÀM CHO PHẦN DETAILS KHÔNG THỂ SCROLL ĐÚNG  */}
                {data.messageId != 0 ? data.body :
                    (data.viewType == "group" ? data.body : "CHI TIẾT BỘ SỐ:" + data.mienText)
                }
            </div>
            {!hideToolbar && <div className="form-header small">
                <div className="form-header left-panel">
                    {data.messageId != 0 && <div>Tin { soTin}</div>}
                    <div className="time-style">
                        {data.messageId != 0 ? data.time : getDateStringVN(data.date)}
                    </div>
                </div>
                <div className="form-header right-panel">
                    {
                        // Hiển thị phần tổng hợp
                        data.viewType == "group" && data.messageId == 0 &&
                        <Button onClick={(event) => {
                            if (event.stopPropagation) {
                                event.preventDefault();
                                event.stopPropagation();
                                if (onReloadItem)
                                    onReloadItem(messageIndex)
                            }

                        }}
                            round
                            size="smaller"
                            color="translucent" >
                            <i className="fa-solid fa-rotate"></i>
                        </Button>
                    }
                    {
                        <Button onClick={handleDownloadHtml}
                            round
                            size="smaller"
                            color="translucent" >
                            <i className="fa-solid fa-file-arrow-down"></i>
                        </Button>
                    }
                    {
                        data.messageId != 0 &&
                        <Button onClick={(event) => {
                            if (event.stopPropagation) {
                                event.preventDefault();
                                event.stopPropagation();
                                store.dispatch(updateEditedMessageId({ editingMessage: data }))
                                onChangeScreen(LotScreenSettings.NHAP_TIN_NHAN_SCREEN)
                            }

                        }}
                            round
                            size="smaller"
                            color="translucent" >
                            <i className="fas fa-edit"></i>
                        </Button>
                    }
                    {
                        data.messageId != 0 &&
                        <Button onClick={(event) => {
                            if (event.stopPropagation) {
                                event.preventDefault();
                                event.stopPropagation();
                                onRemoveItem(messageIndex)
                            }

                        }}
                            round
                            size="smaller"
                            color="translucent" >
                            <i className="fas fa-trash"></i>
                        </Button>
                    }
                    {
                        data.messageId != 0 &&
                        <Button onClick={(event) => {
                            if (event.stopPropagation) {
                                event.preventDefault();
                                event.stopPropagation();
                                copyTextToClipboard(data.body)
                                setState(prev => ({
                                    ...prev, snackbarOpen: true,
                                    snackbarMessage: "Đã copy nội dung tin"
                                }))
                            }

                        }}
                            round
                            size="smaller"
                            color="translucent" >
                            <i className="fas fa-copy"></i>
                        </Button>
                    }
                    {
                        data.viewType == "group" &&
                        <Button onClick={(event) => {
                            if (event.stopPropagation) {
                                event.preventDefault();
                                event.stopPropagation();
                                onChangeViewType("details", messageIndex)
                            }

                        }}
                            round
                            size="smaller"
                            color="translucent" >
                            <i className="fa-regular fa-file-lines"></i>
                        </Button>
                    }
                    {
                        // hiển thị phần chi tiết
                        data.viewType == "details" &&
                        <Button onClick={(event) => {
                            if (event.stopPropagation) {
                                event.preventDefault();
                                event.stopPropagation();
                                onChangeViewType("group", messageIndex)

                            }

                        }}
                            round
                            size="smaller"
                            color="translucent" >
                            <i className="far fa-credit-card"></i>
                        </Button>
                    }
                </div>
            </div>
            }
            <Snackbar isOpen={state.snackbarOpen} message={state.snackbarMessage}
                onClose={() => { setState(prev => ({ ...prev, snackbarOpen: false })) }}
                triggerTime={JSON.stringify(new Date())}
            />
        </div>
    )
}
export default memo(MessageView)